import { render } from "./BasePaginationTab.vue?vue&type=template&id=4894d6a8"
import script from "./BasePaginationTab.vue?vue&type=script&lang=js"
export * from "./BasePaginationTab.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__